<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row style="padding-top: 15px">
      <van-col span="24" class="topSection">
        <img
          src="../images/common/backArrow.png"
          class="imageleft"
          @click="$router.go(-1)"
        />

        <p style="color: #ffffff; font-size: 26px">{{ title }}</p>
      </van-col>
    </van-row>
    <van-row style="padding-top: 25px">
      <div class="guideBody" v-html="content">
        <p style="color: #ffffff; font-size: 26px; text-align: center" />

        <p
          style="
            color: #ffffff;
            font-size: 16px;
            text-align: center;
            padding: 20px 0px;
          "
        />
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import Fetch from "../../utils/fetch";
import { Icon, Col, Row } from "vant";
Vue.use(Icon).use(Row).use(Col);

export default {
  name: "info",
  components: {
    Header,
  },
  data() {
    return {
      title: "",
      content: "",
      endPoint: "",
    };
  },
  mounted() {
    this.endPoint = this.$route.params.id;
    this.getData();
  },
  methods: {
    getData() {
      Fetch("/Article/" + this.endPoint).then((res) => {
        if (res.code == 1) {
          this.content = res.data.content;
          this.title = res.data.title;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  // align-items: center;
  display: flex;
  justify-content: center;
}

.imageleft {
  height: 28px;
  width: auto;
  position: absolute;
  left: 8px;
}

.guideBody {
  padding: 10px;
  border: 2px solid #ffffff;
  border-radius: 15px;
  margin: 0px 15px 15px;
  background: #ebebeb29;
}
</style>
